var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.$store.state.errorFlag)?_c('NotFound'):[_c('Locale'),_c('ListMenu'),_c('Footer')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }